import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { PATHS } from "../../../../_constants/PATHS";
import { deleteFromWishlist } from "../../../../_services/Arya2.0/MyWishlist";
import { addToWishlist } from "../../../../_services/Arya2.0/MyWishlist/api";
import Loader from "../CommonComponents/Loader/Loader";
import { customToastr } from "../CustomToastr";
import CommonSupplies from "./CommonSupplies";
import { buySellData } from "./FetchData";

const PopularSupplies = (props) => {
  const [data, setData] = useState([]);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { t: translation } = useTranslation();
  const getData = async () => {
    if (props.flag) {
      setIsLoading(true);
    }
    setData(await buySellData("sell", props.commoditySelected, translation));
    props.setApiHitCount && props.setApiHitCount();

    setIsLoading(false);
  };
  useEffect(() => {
    if (
      !Array.isArray(props.commoditySelected) ||
      (Array.isArray(props.commoditySelected) && props.commoditySelected.length)
    ) {
      getData();
    }
  }, [props.commoditySelected]);
  const onSimilarLeadHeartClick = async (e, lead_id) => {
    e.preventDefault();
    e.stopPropagation();
    let index = data.findIndex((el) => el.lead_id == lead_id);
    if (index < 0) return;
    //if lead is bookmarked
    if (data[index].isBookMarked) {
      setIsLoading(true);

      try {
        const res = await deleteFromWishlist({
          object_id: lead_id,
          object_type: "supplies",
        });

        if (res.status_code === 200) {
          data[index].isBookMarked = false;
          setData([...data]);
          customToastr({ text: "Removed from favourites" });
        }
      } catch (e) {
      } finally {
        setIsLoading(false);
      }
      //call delete api
      // await
      // similarLeadData[index];
    } else {
      let payload = {
        object_id: lead_id,
        object_type: "supplies", //auctions,warehouse,supplies,demands
      };
      // add to bookmark
      setIsLoading(true);
      try {
        const res = await addToWishlist(payload);
        if (res.status_code === 200) {
          data[index].isBookMarked = true;
          customToastr({ text: "Added to favourites" });

          setData([...data]);
        }
      } catch (e) {
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <Loader isLoading={isLoading} />
      {data?.length ? (
        <CommonSupplies
          isRequirementCard
          title="Popular Supplies"
          subtitle={"Supplies which are popular in India and world"}
          data={data}
          onHeartClick={onSimilarLeadHeartClick}
          onClick={() =>
            history.push(PATHS.SELL_REQUIREMENT, {
              commodityFilter: props?.commoditySelected?.map((item) => {
                return {
                  data: item?.commodity,
                  value: item?.commodity,
                  label: item?.commodity,
                };
              }),
            })
          }
        />
      ) : (
        ""
      )}
    </>
  );
};
export default PopularSupplies;
